{
  "en": {
    "pagination": {
      "previous": "Previous page",
      "next": "Next page",
      "page_report": "Page {page} of {total}",
      "report": "Showing {first} to {last} of {total}",
      "total": "Total items: {total}"
    }
  }
}
